import { trackUmamiEvent } from './umami';

export type GiftClickEvent = 'santa_gift_thank_clicked' | 'santa_gift_spread_clicked' | 'santa_gift_checkout_clicked';
export type GiftEvent = GiftClickEvent | 'santa_gift_received' | 'santa_gift_thanked' | 'santa_gift_dismissed' | 'santa_gift_received_frame_chosen' | 'santa_gift_received_frame_clicked';
export type GiftEventContext = { screen?: string; frame_type?: string | null; box_count?: number; dismissal?: 'close' | 'continue'; anonymous?: boolean; message_type?: 'predefined' | 'custom' | 'empty'; message_key?: string };
const internalEvents = new Set<GiftEvent>(['santa_gift_thank_clicked', 'santa_gift_spread_clicked', 'santa_gift_checkout_clicked']);
/** No personal data; each analytics destination fails independently of the gift flow. */
export function trackGiftEvent(event: GiftEvent, context: GiftEventContext = {}): void {
  try { void Promise.resolve(trackUmamiEvent(event, context)).catch(() => {}); } catch { /* Best effort. */ }
  if (!internalEvents.has(event)) return;
  try {
    void fetch('/api/analytics/events', {
      method: 'POST', credentials: 'same-origin', keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ eventName: event, context }),
    }).catch(() => {});
  } catch { /* Analytics must never block a click. */ }
}
